export const DocumentSignature = () => {
  return (
    <div className="text-right text-sm text-gray mb-8">
      <p>株式会社Masentic - All Rights Reserved © 2025</p>
      <p>Copyright © 2025</p>
    </div>
  );
};
